import React from "react";

import { Route, Routes } from "react-router-dom";

import { Page404 } from "@components/title-slide-view";

import { BreakdownsPage } from "./breakdowns-page";
import { EditBreakdownPage } from "./edit-breakdown-page";

export default () => (
  <Routes>
    <Route index element={<BreakdownsPage />} />
    <Route path="/:id/edit" element={<EditBreakdownPage />} />
    <Route
      path="/*"
      element={
        <div className="overflow-hidden h-100">
          <Page404 />
        </div>
      }
    />
  </Routes>
);
